module.exports = __webpack_public_path__ + "static/media/buy_donate_map_important.28d5c349.svg";